module.exports = __webpack_public_path__ + "img/test-drive-daily_commute.f131ecbd.svg";